

export default function CountsList({
    data
}) {

    const dataSample = [
        {
            "key": "Group A",
            "value": 11,
            "foregroundClass": "bg-light",
            "backgroundClass": "text-dark",
        }
    ]

    return (
        <ul className="list-group">
            {
                data.map(item => (
                    <li key={item.key} className="list-group-item d-flex justify-content-between align-items-center bg-dark">
                        <span className={`badge rounded-pill ${item.backgroundClass} ${item.foregroundClass}`}>{item.key}</span>
                        <span className="badge bg-black bg-opacity-10 rounded-pill"><h6>{item.value || 0}</h6></span>
                    </li>

                ))
            }
        </ul>
    )
}